const button = {
  base: {
    fontWeight: "500",
    cursor: "pointer",
    display: "inline-block",
    lineHeight: "1.125rem",
    padding: ".5rem 1rem",
    margin: 0,
    height: "auto",
    verticalAlign: "middle"
  }
};

export default button;



// WEBPACK FOOTER //
// ./src/styles/button.js